import { logout, setIsLoggedIn } from "../reducer/action";
import tokenHttpClient from "./httpClient";

const AxiosInterceptorsSetup = (dispatch, disableNotification) => {
  tokenHttpClient.interceptors.request.use(
    async (config) => {
      const localState = JSON.parse(
        localStorage.getItem("DAS_VENDOR_INTERNAL_STATE")
      );
      const auth = localState?.auth;
      const token = auth?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        dispatch(setIsLoggedIn(false));

        return;
      }
      return config;
    },
    (error) => {
      throw error;
    }
  );

  tokenHttpClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error?.response?.status === 403) {
        dispatch(setIsLoggedIn(false));

        dispatch(logout());
      }
      if (error?.response?.status === 409) {
        disableNotification();
        dispatch(setIsLoggedIn(false));
        dispatch(logout());
      }
    }
  );
};
export default AxiosInterceptorsSetup;
